module.exports = __webpack_public_path__ + "img/facebook.11bf247a.svg";